module.exports = __webpack_public_path__ + "static/media/7.e76c9984.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/shoes/7.png
// module id = 1104
// module chunks = 0